import { render, staticRenderFns } from "./AspectTableSingleComponents.vue?vue&type=template&id=1afb3c50&scoped=true&"
import script from "./AspectTableSingleComponents.vue?vue&type=script&lang=js&"
export * from "./AspectTableSingleComponents.vue?vue&type=script&lang=js&"
import style0 from "./AspectTableSingleComponents.vue?vue&type=style&index=0&id=1afb3c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb3c50",
  null
  
)

export default component.exports